import React, { Component } from 'react';
import { Row } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import { ActionStatus, GamePlayerStatus, Room } from '../../../../../Constants';
import { playersWhichMayAcceptThisCard } from '../../../../Game/GamePlayerInfo';
import {
    availableLaneCards,
    CARD_FACTIONS, emptyAvailableLanes,
    getSingleCardData,
    SEEKERS,
    SPECIAL_GUESTS
} from '../../../Common/CardUtilities';
import { available_guest_orbits } from '../../../Common/StationUtilities';
import { getCardTextureUrl, getFactionTextureId, getFactionTextureUrl, getTextureUrl } from '../../../Common/TextureTools';

import '../../../Controls/action-grid.css';
import '../../../Choices/lodging-action.css'
import {
    CLEAR_ACTION_SELECTION_EVENT,
} from '../../../../Dashboard/ActionWindows/CurrentAction';


class FactionIcon extends Component {
    render() {
        let textureUrl;
        let factionId = this.props.factionId;
        textureUrl = getFactionTextureUrl(factionId);
        return <div id={'special-guest-target'}>
            <img
                src={textureUrl}
                alt="advertisement"
                style={{ width: '60px' }}
                onClick={this.props.onClick}
            />
        </div>;
    }
}


class AdvertisementIcon extends Component {

    render() {
        let textureUrl;
        let textureId = this.props.textureId;
        if (this.props.cardId) {
            textureUrl = getCardTextureUrl(this.props.cardId);
        } else {
            textureUrl = getTextureUrl(textureId);
        }
        return <img
            src={textureUrl}
            alt="advertisement"
            style={{ width: '22vw' }}
        />;
    }
}


export class AdvertisementPossibilities extends Component {

    constructor(props) {
        super(props);
        this.api = this.props.app.game.seatedController.gamePlayerApi;
        this.state = {
            cardId: null,
            orbitIndex: null,
            isSpecial: false,
            textureId: 75,
            orbitRecord: null,
            specialTargets: [],
        };

        this.available = [];
        this.drawable = [];
        this.possibleTargets = [];
        this.targetsBySeat = [];
    }

    componentDidMount() {
        this.highlight();
        window.addEventListener('river-mounted-event', this.highlight);
        window.addEventListener(
            CLEAR_ACTION_SELECTION_EVENT, this.clearSelection);
    }

    // Singleton lifecycle: this component is mounted once per seated
    // Dashboard (above the preset branch), not conditionally per
    // game-state. It owns the ADVERTISING_ID + WAIT_ID substate and
    // gates its dispatches internally — see isActive / highlight /
    // componentDidUpdate.
    componentDidUpdate(prevProps) {
        const wasActive = this.isActive(prevProps);
        const nowActive = this.isActive(this.props);
        if (!wasActive && nowActive) {
            // Entered ADVERTISING + WAIT_ID — dispatch the initial
            // highlight + dock/discard/competitor lights.
            this.highlight();
        } else if (wasActive && !nowActive) {
            // Left ADVERTISING + WAIT_ID — clear all four channels
            // and reset internal selection state. done() already does
            // exactly this; reuse it instead of duplicating clears.
            this.done();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('river-mounted-event', this.highlight);
        window.removeEventListener(
            CLEAR_ACTION_SELECTION_EVENT, this.clearSelection);
        window.dispatchEvent(new Event('clear-tradelanes-highlight-event'));
        window.dispatchEvent(new Event('clear-discard-event'));
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
        window.dispatchEvent(
            new Event('clear-competitors-highlight-event'));
    }

    // True only while this seat is in the ADVERTISING_ID + WAIT_ID
    // substate this component services. Every outbound dispatch gates
    // on this so the always-mounted singleton stays silent otherwise.
    isActive = (props) => {
        if (!props || !props.gamePlayerData) return false;
        return props.gamePlayerData.status === GamePlayerStatus.ADVERTISING_ID
            && props.gamePlayerData.action_status === ActionStatus.WAIT_ID;
    };

    // Reset the picked-orbit state (first click selected an orbit
    // card and primed dock / discard / target callbacks; second
    // click hasn't landed yet). Calls done() to wipe state + the
    // dock/discard/competitor highlight overlays, then highlight()
    // to relight the initial available-orbits set. Fired by the
    // Clear button on CurrentAction.
    clearSelection = () => {
        if (this.state.orbitIndex === null) return;
        this.done();
        this.highlight();
    };

    highlight = () => {
        if (!this.isActive(this.props)) return;
        this.available = available_guest_orbits(this.props.gameData.orbits);
        this.drawable = emptyAvailableLanes(this.props.gameData);
        let highlightedOrbits = [ ...this.available, ...this.drawable ];
        window.dispatchEvent(
            new CustomEvent('highlight-tradelanes-event',
                {
                    detail: {
                        tradelanes: highlightedOrbits,
                        callback: this.onOrbitClick
                    }
                }));
    }

    onOrbitClick = (orbitIndex) => {
        let gamePlayerData = this.props.gamePlayerData;
        let orbits = this.props.gameData.orbits;
        let cardId = orbits[orbitIndex];
        let orbitRecord = getSingleCardData(
            cardId, this.props.gameData, gamePlayerData)

        if (!cardId) {
            if (this.drawable.includes(orbitIndex)) {
                this.draw(orbitIndex);
            }
            return;
        }
        if (this.available.includes(orbitIndex)) {
            // Manual 7.2.5: Guest Referral applies to any guest, not just
            // special. Compute targeting unconditionally.
            const specialTargets = this.targetPlayersBySeat(orbitRecord);
            this.setState({
                cardId: cardId,
                orbitIndex: orbitIndex,
                isSpecial: orbitRecord.isSpecial,
                orbitRecord: orbitRecord,
                specialTargets: specialTargets,
            });
            window.dispatchEvent(
                new CustomEvent('highlight-docks-event',
                    {
                        detail: {
                            highlightedDocks: orbitRecord.availableDocks,
                            callback: this.onDockClick
                        }
                    }));
            window.dispatchEvent(
                new CustomEvent('highlight-discard-event',
                    {
                        detail: {
                            tradelane: orbitIndex,
                            callback: this.clickDiscard
                        }
                    }));
            // Additive: also light up the eligible competitor hotels as
            // a second referral-target path. The swiper keeps working.
            if (this.possibleTargets.length > 0) {
                const playerIds = this.possibleTargets.map((gp) => gp.id);
                window.dispatchEvent(
                    new CustomEvent('highlight-competitors-event',
                        {
                            detail: {
                                playerIds: playerIds,
                                callback: (playerId) => {
                                    this.api.clickSpecialTarget(
                                        playerId, orbitIndex);
                                },
                            }
                        }));
            }
        } else {
            console.log('miss orbit click');
        }
    };

    targetPlayersBySeat = (orbitRecord) => {
        let possibleTargets = playersWhichMayAcceptThisCard(
            this.props.gameData, orbitRecord.id).filter(gamePlayer => gamePlayer.id !== this.props.gamePlayerData.id);
        this.possibleTargets = possibleTargets;
        this.targetsBySeat = [ 0, 1, 2, 3, 4, 5 ].map((seatNumber, index) => {
            let playerIndex = possibleTargets.findIndex(
                gamePlayer => gamePlayer.seat === seatNumber);
            if (playerIndex < 0) {
                return null;
            }
            let gamePlayerData = possibleTargets[playerIndex];
            let factionId = gamePlayerData.faction;
            let factionTextureId = getFactionTextureId(factionId);
            return factionTextureId
        });
        return this.targetsBySeat;
    }

    draw = (orbitIndex) => {
        this.api.draw(orbitIndex);
        this.done();
    };


    onDockClick = (dockIndex) => {
        this.api.placeGuest(
            dockIndex, this.state.orbitIndex)
        this.done();
    };

    clickDiscard = () => {
        this.api.clickDiscard(this.state.orbitIndex);
        this.done();
    }

    done = () => {
        this.setState({ cardId: null, orbitIndex: null, isSpecial: false });
        window.dispatchEvent(new Event('clear-tradelanes-highlight-event'));
        window.dispatchEvent(new Event('clear-discard-event'));
        window.dispatchEvent(new Event('clear-docks-highlight-event'));
        window.dispatchEvent(
            new Event('clear-competitors-highlight-event'));
    }

    // No visible UI: the AC is a pure dispatcher singleton. Advertisement
    // targeting now happens through the player boards via the
    // highlight-competitors-event channel (CompetitorGrid /
    // CompetitorsWindow), not the old faction-icon swiper strip — which
    // also rendered as a stray strip at the dashboard root once the AC
    // was hoisted out of the "Your Hotel" floating window.
    render() {
        return <></>;
    }
}


function vanguardLodgingAvailableInPool(gameData, cardId) {
    const cardFaction = CARD_FACTIONS[cardId];
    const factionIndex = cardFaction - 1;
    const vanguardRoom = Room.UNUPGRADED_LODGING_IDS[factionIndex];
    const pool = gameData.lodging_pool[factionIndex];
    return pool.includes(vanguardRoom);
}


export function vanguardPossibilities(gameData, gamePlayerData, cardId) {
    const cardFaction = CARD_FACTIONS[cardId];
    const factionIndex = cardFaction - 1;
    const vanguardRoom = Room.UNUPGRADED_LODGING_IDS[factionIndex];
    let possibilities = [];
    let firstNone = false;
    const available = vanguardLodgingAvailableInPool(gameData, cardId);
    if (!available) return possibilities;
    gamePlayerData.lodging.forEach((roomId, lodgingIndex) => {
        let value = roomId === vanguardRoom;
        if (!firstNone && roomId === null) {
            firstNone = true;
            value = true;
        }
        possibilities.push(value);
    });
    return possibilities;
}
